import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TenantMsGraphOptions } from 'app/api/models/tenant/TenantMsGraphOptions';
import { NotificationService } from 'app/api/services/notificationService';
import { TenantsService } from 'app/state/tenants.service';
import { TrackRender } from 'app/shared/front-perfomance';

@TrackRender()
@Component({
    selector: 'app-tenant-ms-graph-edit-page',
    templateUrl: './tenant-ms-graph-edit-page.component.html',
    styleUrls: ['./tenant-ms-graph-edit-page.component.scss'],
    standalone: false
})
export class TenantMsGraphEditPageComponent {
  constructor(
    public notificationService: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  msGraphOptions: TenantMsGraphOptions | undefined;
  @Input() id: string | undefined;
  @Input() tenantId: string = '';

  @Output() onCloseModal = new EventEmitter<void>();

  onCloseModall() {
    this.onCloseModal.emit();
  }

  ngOnInit(): void {
    if (this.id) {
      this.notificationService.loadMsGraphOptions(this.id).subscribe((x) => {
        this.msGraphOptions = x;
      });
    }
  }

  updateCreateMsGraphOptions(data: TenantMsGraphOptions) {
    data.tenantId = this.tenantId;
    if (this.id) {
      this.notificationService.updateMsGraphOptions(data).subscribe({
        complete: () => {
          this.router.navigate([`tenants/emails/${this.tenantId}`]);
        },
      });
    } else {
      data.tenantId = this.tenantId;
      this.notificationService.createMsGraphOptions(data).subscribe({
        complete: () => {
          this.router.navigate([`tenants/emails/${this.tenantId}`]);
        },
      });
    }
  }
}
